import PaymentMethod from './PaymentMethod';
import { EPaymentMethodTypes } from '@/helpers/enums';
import IEmpiricusRewardsPaymentMethod from '@/interfaces/Methods/EmpiricusRewards';

export default class EmpiricusRewardsPaymentMethod extends PaymentMethod implements IEmpiricusRewardsPaymentMethod {
  type: EPaymentMethodTypes = EPaymentMethodTypes.empiricusRewards;

  constructor (method?: IEmpiricusRewardsPaymentMethod) {
    super();

    this.build(method);
  }

  build (method?: IEmpiricusRewardsPaymentMethod): EmpiricusRewardsPaymentMethod {
    Object.assign(this, { ...method });

    return this;
  }
}
